<template>
  <div class="home">
    <div class="daily-header">
      <div class="daily-date" style="color: #00CC88;">数据日期：{{isLoading?'加载中...':dataTime}}</div>销售区域日报
      <div class="select" style="margin-bottom: 20px">

      <el-select v-model="value1" placeholder="请选择月份" @change="changeMonthFun1">
        <el-option
          v-for="item in options.slice(1)"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>

    </div>
      <div class="downexcel">
        <div class="week-button" @click="downloadArea">区域报表下载</div>
        <div class="day-button" @click="downloadPro">产品线报表下载</div>
      </div>
    </div>
    <div class="daily-top">
      <div class="left">
        <div class="tj-text">
          甘肃
          <span>（{{parseInt(gansu*100)}}%）</span>
        </div>
        <div class="nx-text">
          宁夏
          <span>（{{parseInt(ningxia*100)}}%）</span>
        </div>
        <div class="qh-text">
          青海
          <span>（{{parseInt(qinghai*100)}}%）</span>
        </div>
        <div class="xz-text">
          西藏
          <span>（{{parseInt(xizang*100)}}%）</span>
        </div>
      </div>
      <div class="right">
        <div class="area">
          <div class="area-square gs-color"></div>
          <div class="area-text">甘肃区域</div>
        </div>
        <div class="area">
          <div class="area-square nx-color"></div>
          <div class="area-text">宁夏区域</div>
        </div>
        <div class="area">
          <div class="area-square qh-color"></div>
          <div class="area-text">青海区域</div>
        </div>
        <div class="area">
          <div class="area-square xz-color"></div>
          <div class="area-text">西藏区域</div>
        </div>
        <div class="cell">
          <a-progress
            class="cell-persent"
            type="circle"
            :percent="101"
            :width="70"
            strokeColor="#2461EF"
            :format="() => `${parseInt(xitongnei*100)}%`"
          />
          <div class="cell-text">系统内</div>
        </div>
      </div>
    </div>
    <div class="daily-top-2">
      <div class="charts" style="width: 100%;height: 378px;margin:0 0 20px 0;">
        <!-- <div class="charts-title">区域合计</div> -->
        <div id="chart2020" class="charts-content" style="width: 100%;height: 338px;"></div>
      </div>
    </div>
    <div class="daily-top-2">
      <div class="charts" style="width: 50%;height: 378px;margin:0 20px 20px 0;">
        <!-- <div class="charts-title">区域合计</div> -->
        <div id="chart1" class="charts-content" style="width: 100%;height: 378px;"></div>
      </div>
      <div class="charts" style="width: 50%;height: 378px;margin-bottom:20px;">
        <!-- <div class="charts-title">区域合计</div> -->
        <div id="chart2" class="charts-content" style="width: 100%;height: 378px;"></div>
      </div>
    </div>
    <div class="daily-top-2">
      <div class="charts" style="width: 50%;height: 378px;margin:0 20px 20px 0;">
        <div id="chart3" class="charts-content" style="width: 100%;height: 338px;"></div>
      </div>
      <div class="charts" style="width: 50%;height: 378px;margin:0 0 20px 0;">
        <div id="chart5" class="charts-content" style="width: 100%;height: 338px;"></div>
      </div>
    </div>
    <div class="daily-top-2">
      <div class="charts" style="width: 50%;height: 378px;margin:0 20px 20px 0;">
        <div id="chart6" class="charts-content" style="width: 100%;height: 338px;"></div>
      </div>
      <div class="charts" style="width: 50%;height: 378px;margin:0 0 20px 0;">
        <div id="chart7" class="charts-content" style="width: 100%;height: 338px;"></div>
      </div>
    </div>
    <div class="daily-top-2">
      <div class="charts" style="width: 50%;height: 378px;margin:0 20px 20px 0;">
        <div id="chart8" class="charts-content" style="width: 100%;height: 338px;"></div>
      </div>
      <div class="charts" style="width: 50%;height: 378px;margin:0 0 20px 0;">
        <div id="chart9" class="charts-content" style="width: 100%;height: 338px;"></div>
      </div>
    </div>
    <div class="daily-top-2">
      <div class="charts" style="width: 50%;height: 378px;margin:0 20px 20px 0;">
        <div id="chart10" class="charts-content" style="width: 100%;height: 338px;"></div>
      </div>
      <div class="charts" style="width: 50%;height: 378px;margin:0 0 20px 0;">
        <div id="chart11" class="charts-content" style="width: 100%;height: 338px;"></div>
      </div>
    </div>
    <div class="daily-top-2">
      <div class="charts" style="width: 50%;height: 378px;margin:0 20px 20px 0;">
        <div id="chart12" class="charts-content" style="width: 100%;height: 338px;"></div>
      </div>
      <div class="charts" style="width: 50%;height: 378px;margin:0 0 20px 0;">
        <div id="chart13" class="charts-content" style="width: 100%;height: 338px;"></div>
      </div>
    </div>
    <div class="daily-top-2">
      <div class="charts" style="width: 50%;height: 378px;margin:0 20px 20px 0;">
        <div id="chart14" class="charts-content" style="width: 100%;height: 338px;"></div>
      </div>
      <div class="charts" style="width: 50%;height: 378px;margin:0 0 20px 0;">
        <div id="chart15" class="charts-content" style="width: 100%;height: 338px;"></div>
      </div>
    </div>
    <div class="select" style="margin-bottom: 20px">
      <el-select v-model="value" placeholder="请选择" @change="changeMonthFun">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
          
        ></el-option>
      </el-select>
    </div>
    <div class="table">
      <table class="table">
        <tr>
          <th v-for="(item,index) in tableData" :key="index">{{item.label}}</th>
        </tr>
        <tr>
          <td v-for="(item,index) in tableData" :key="index">{{item.value}}</td>
        </tr>
      </table>
    </div>
    <div>
      <table class="storetable">
        <tr>
          <th v-for="(item,index) in storeData" :key="index">{{item.label}}</th>
        </tr>
        <tr>
          <td v-for="(item,index) in storeData" :key="index">{{item.value}}</td>
        </tr>
      </table>
    </div>
    <div class="ranklist">
      <div class="rankitem">
        <div class="staffTitle">
          <div class="jiangbeiimg">
            <img src="https://static.sprucesmart.com/lzrh/jiangbei.png" alt />
          </div>车用油榜单前五
        </div>
        <div class="scroll">
          <div class="content" v-if="hasdata">
            <div
              class="scrollitem"
              v-for="(item,index) in caroilrank"
              :key="index"
              :style="note[index]"
            >
              <span class="icon">
                <img :src="item.icon" alt />
              </span>
              <span class="staffindex">NO.{{index+1}}</span>
              <span class="staffname">{{item.name}}</span>
              <div class="staffavatar">
                <img src="https://static.sprucesmart.com/lzrh/avatar.png" alt />
              </div>
            </div>
          </div>
          <div class="content" v-else style="text-align:center;">暂无数据</div>
        </div>
      </div>
      <div class="rankitem">
        <div class="staffTitle">
          <div class="jiangbeiimg">
            <img src="https://static.sprucesmart.com/lzrh/jiangbei.png" alt />
          </div>车用油再接再厉
        </div>
        <div class="listhreecontent" v-if="hasdata">
          <div class="firstlist" v-for="(item,index) in lastcaroilrank" :key="index">
            <div class="bigicon">
              <!-- <img src="https://static.sprucesmart.com/lzrh/lasticon.png" alt /> -->
              {{item.lastcaroilrank}}
            </div>
            <div class="staffinfo">
              <!-- <span>NO.</span> -->
              <span>{{item.name}}</span>
              <!-- <div class="jixgz">绩效工资：{{firstaffvalue}}</div> -->
            </div>
            <div class="staffavatar">
              <img src="https://static.sprucesmart.com/lzrh/avatar.png" alt />
            </div>
          </div>
        </div>
        <div class="listhreecontent" v-else style="text-align:center;">暂无数据</div>
      </div>
      <div class="rankitem">
        <div class="staffTitle">
          <div class="jiangbeiimg">
            <img src="https://static.sprucesmart.com/lzrh/jiangbei.png" alt />
          </div>工业油榜单前五
        </div>
        <div class="scroll">
          <div class="content" v-if="hasdata">
            <div
              class="scrollitem"
              v-for="(item,index) in gongyeyourank"
              :key="index"
              :style="note[index]"
            >
              <span class="icon">
                <img :src="item.icon" alt />
              </span>
              <span class="staffindex">NO.{{index+1}}</span>
              <span class="staffname">{{item.name}}</span>
              <div class="staffavatar">
                <img src="https://static.sprucesmart.com/lzrh/avatar.png" alt />
              </div>
            </div>
          </div>
          <div class="content" v-else style="text-align:center;">暂无数据</div>
        </div>
      </div>
      <div class="rankitem">
        <div class="staffTitle">
          <div class="jiangbeiimg">
            <img src="https://static.sprucesmart.com/lzrh/jiangbei.png" alt />
          </div>工业油再接再厉
        </div>
        <div class="listhreecontent" v-if="hasdata">
          <div class="firstlist" v-for="(item,index) in lastgongyeyourank" :key="index">
            <div class="bigicon">
              <!-- <img src="https://static.sprucesmart.com/lzrh/lasticon.png" alt /> -->
              {{item.lastgongoilrank}}
            </div>
            <div class="staffinfo">
              <!-- <span>NO.</span> -->
              <span>{{item.name}}</span>
              <!-- <div class="jixgz">绩效工资：{{firstaffvalue}}</div> -->
            </div>
            <div class="staffavatar">
              <img src="https://static.sprucesmart.com/lzrh/avatar.png" alt />
            </div>
          </div>
        </div>
        <div class="listhreecontent" v-else style="text-align:center;">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getdailypanel } from "@/api/panelapi";
import { tabledata } from "@/api/tablecompleteapi";
import { storedata } from "@/api/personalstoreapi";
import { businessRankdata } from "@/api/businessRankapi";
import { selectdowndata } from '@/api/selectdowndataapi'
export default {
  name: "Home",
  data() {
    return {
      isLoading: true,
      dataTime: "",
      gansu: 0,
      ningxia: 0,
      qinghai: 0,
      xizang: 0,
      xitongnei: 0,
      username: "",
      option: {
        title: {
          text: "",
        },
        tooltip: {
          trigger: "axis",
          color: ["#ff0000", "#00ff00", "#0000ff"],
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        // 出现滚动条
        // dataZoom: [
        //   {
        //     show: true,
        //     realtime: true,
        //     start: 0,
        //     end: 50,
        //   },
        //   {
        //     type: "inside",
        //     realtime: true,
        //     start: 0,
        //     end: 50,
        //   },
        // ],
        grid: {
          left: "2%",
          right: "6%",
          bottom: "3%",
          containLabel: true,
        },
        legend: {
          data: ["销量"],
        },
        xAxis: {
          type: "category",
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: 0,
          },
          data: [],
        },
        yAxis: [
          {
            type: "value",
            splitLine: {
              show: false,
            },
            name: "/吨",
          },
          {
            type: "value",
            scale: true,
            name: "完成率：%",
            min: -30,
          },
        ],
        series: [
          {
            name: "任务量",
            type: "bar",
            barWidth: "15",
            yAxisIndex: 0,
            barGap: 0,
            itemStyle: {
              normal: {
                color: "#776EE9", // 紫色
              },
            },
            data: [],
          },
          {
            name: "结算量",
            type: "bar",
            barWidth: "15",
            yAxisIndex: 0,
            barGap: 0,
            itemStyle: {
              normal: {
                color: "#E86D8B", // 粉色
              },
            },
            data: [],
          },
          {
            name: "完成率",
            type: "line",
            yAxisIndex: 1,
            barGap: 0,
            smooth: true,
            itemStyle: {
              normal: {
                color: "#509EF3", // 蓝色
              },
            },
            data: [],
          },
          {
            name: "同期",
            type: "bar",
            barWidth: "15",
            yAxisIndex: 0,
            barGap: 0,
            itemStyle: {
              normal: {
                color: "#F2A75B", //橘色
              },
            },
            data: [],
          },
          {
            name: "增减量",
            type: "bar",
            barWidth: "15",
            yAxisIndex: 0,
            barGap: 0,
            itemStyle: {
              normal: {
                color: "#64C67B", // 绿色
              },
            },
            data: [],
          },
          {
            name: "增减率",
            type: "line",
            yAxisIndex: 1,
            barGap: 0,
            smooth: true,
            itemStyle: {
              normal: {
                color: "#0BE1B8",
              },
            },
            data: [],
          },
        ],
      },
      note: [
        {
          backgroundImage: "url(" + require("../../assets/firstbg.png") + ")",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        },
        {
          backgroundImage: "url(" + require("../../assets/secondbg.png") + ")",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          marginTop: "0",
        },
        {
          backgroundImage: "url(" + require("../../assets/thirdbg.png") + ")",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          marginTop: "0",
        },
        {
          backgroundImage: "url(" + require("../../assets/fourth.png") + ")",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          marginTop: "0",
        },
        {
          backgroundImage: "url(" + require("../../assets/fifth.png") + ")",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          marginTop: "0",
        },
      ],
      tableData: [], // 完成情况
      storeData: [], // 个人分数
      caroilrank: [], // 车用油前五
      lastcaroilrank: [], // 车用油后五
      gongyeyourank: [], // 工业油前五
      lastgongyeyourank: [], // 工业油后五
      options: [
        {
          value: "",
          label: "",
        }
      ],
      value: "nowmonth",
      value1: 0,
      hasdata: true
    };
  },
  created() {
    this.getdailyres();
    this.init();
    console.log("value1: 0000---", this.value1)
    
  },
  methods: {
    init() {
      var date = new Date();
      // var nowmonth = date.getMonth()+1
      // this.value = nowmonth + '月'
      // 获取下拉框内容
      const selectdown = selectdowndata();
      selectdown.then((res) => {
        console.log('selectdowndata', res)
        if (res.data.errno == 0) {
          this.options = res.data.results
          this.value1=this.options.slice(-1)[0].value
          // console.log("---------------",this.options.slice(-1))
          // console.log("this.value1---",this.value1)
          this.value = this.options.slice(-1)[0].value
          const completedata = tabledata(this.value);
        completedata.then((res) => {
          this.tableData = res.data.results;
        });

        const personaldata = storedata(this.value);
        personaldata.then((res) => {
          this.storeData = res.data.results;
        });

        const businessdata = businessRankdata(this.value);
        businessdata.then((res) => {
          if (res.data.errno == 0) {
            this.datatime = res.data.results.date;
            if (res.data.results.che_rank.length !== 0 || res.data.results.gong_rank.length !== 0) {
              this.hasdata = true
              this.caroilrank = res.data.results.che_rank.slice(0, 5);
              this.caroilrank[0].icon =
                "https://static.sprucesmart.com/lzrh/NO1.png";
              this.caroilrank[1].icon =
                "https://static.sprucesmart.com/lzrh/NO2.png";
              this.caroilrank[2].icon =
                "https://static.sprucesmart.com/lzrh/NO3.png";
              this.caroilrank[3].icon =
                "https://static.sprucesmart.com/lzrh/NO4.png";
              this.caroilrank[4].icon =
                "https://static.sprucesmart.com/lzrh/NO5.png";

              this.lastcaroilrank = res.data.results.che_rank.slice(-5).reverse();
              var oldLastLength = res.data.results.che_rank.length;
              this.lastcaroilrank.forEach((item, index) => {
                item.lastcaroilrank = oldLastLength - index;
              });

              this.gongyeyourank = res.data.results.gong_rank.slice(0, 5);
              this.gongyeyourank[0].icon =
                "https://static.sprucesmart.com/lzrh/NO1.png";
              this.gongyeyourank[1].icon =
                "https://static.sprucesmart.com/lzrh/NO2.png";
              this.gongyeyourank[2].icon =
                "https://static.sprucesmart.com/lzrh/NO3.png";
              this.gongyeyourank[3].icon =
                "https://static.sprucesmart.com/lzrh/NO4.png";
              this.gongyeyourank[4].icon =
                "https://static.sprucesmart.com/lzrh/NO5.png";

              this.lastgongyeyourank = res.data.results.gong_rank.slice(-5).reverse();
              var oldLastLength = res.data.results.gong_rank.length;
              this.lastgongyeyourank.forEach((item, index) => {
                item.lastgongoilrank = oldLastLength - index;
              });

            }else {
              this.hasdata = false
              this.caroilrank = [];
              this.lastcaroilrank = [];
              this.gongyeyourank = [];
              this.lastgongyeyourank = []
            }
          }
        });
      
        }
      })
      
      
    },
    changeMonthFun1() {
      this.getdailyres()
      console.log("this.value1---", this.value1)
    },
    changeMonthFun() {
      const completedata = tabledata(this.value);
      completedata.then((res) => {
        // console.log("tabledata", res);
        this.tableData = res.data.results;
      });
      const personaldata = storedata(this.value);
      personaldata.then((res) => {
        // console.log('personaldata',res)
        this.storeData = res.data.results;
      });
      const businessdata = businessRankdata(this.value);
      businessdata.then((res) => {
        if (res.data.errno == 0) {
          console.log("businessdata", res);
          this.datatime = res.data.results.date;
          if (res.data.results.che_rank.length !== 0 || res.data.results.gong_rank.length !== 0) {
            this.hasdata = true
            this.caroilrank = res.data.results.che_rank.slice(0, 5);
            this.caroilrank[0].icon =
              "https://static.sprucesmart.com/lzrh/NO1.png";
            this.caroilrank[1].icon =
              "https://static.sprucesmart.com/lzrh/NO2.png";
            this.caroilrank[2].icon =
              "https://static.sprucesmart.com/lzrh/NO3.png";
            this.caroilrank[3].icon =
              "https://static.sprucesmart.com/lzrh/NO4.png";
            this.caroilrank[4].icon =
              "https://static.sprucesmart.com/lzrh/NO5.png";

            this.lastcaroilrank = res.data.results.che_rank.slice(-5).reverse();
            var oldLastLength = res.data.results.che_rank.length;
            this.lastcaroilrank.forEach((item, index) => {
              item.lastcaroilrank = oldLastLength - index;
            });

            this.gongyeyourank = res.data.results.gong_rank.slice(0, 5);
            this.gongyeyourank[0].icon =
              "https://static.sprucesmart.com/lzrh/NO1.png";
            this.gongyeyourank[1].icon =
              "https://static.sprucesmart.com/lzrh/NO2.png";
            this.gongyeyourank[2].icon =
              "https://static.sprucesmart.com/lzrh/NO3.png";
            this.gongyeyourank[3].icon =
              "https://static.sprucesmart.com/lzrh/NO4.png";
            this.gongyeyourank[4].icon =
              "https://static.sprucesmart.com/lzrh/NO5.png";

            this.lastgongyeyourank = res.data.results.gong_rank.slice(-5).reverse();
            var oldLastLength = res.data.results.gong_rank.length;
            this.lastgongyeyourank.forEach((item, index) => {
              item.lastgongoilrank = oldLastLength - index;
            });
          }else {
            this.hasdata = false
            this.caroilrank = [];
            this.lastcaroilrank = [];
            this.gongyeyourank = [];
            this.lastgongyeyourank = []
          }


        }
      });
    },
    getdailyres() {
      const getdailydata = getdailypanel(this.value1);
      getdailydata.then((res) => {
        this.isLoading = false;
        this.dataTime = res.data.results.last_date;
        // window.localStorage.setItem('latedate',this.dataTime)
        this.gansu = res.data.results.middle_map_data[0].gansu;
        this.ningxia = res.data.results.middle_map_data[0].ningxia;
        this.qinghai = res.data.results.middle_map_data[0].qinghai;
        this.xizang = res.data.results.middle_map_data[0].xizang;
        this.xitongnei = res.data.results.middle_map_data[0].xitongnei;
        res.data.results.pl_data.forEach((item, index) => {
          let tempOption = this.option;
          tempOption.title.text = item.pl_name;
          tempOption.series[0].data = item.pl_plan;
          tempOption.series[1].data = item.pl_balance;
          tempOption.series[2].data = item.pl_bcr;
          tempOption.series[3].data = item.pl_last_month_balance;
          tempOption.series[4].data = item.pl_month_delta_list;
          tempOption.series[5].data = item.pl_month_delta_ratio_list;
          tempOption.xAxis.data = item.area_list;
          let myChart = this.$echarts.init(
            document.getElementById("chart" + item.pl_id)
          );
          myChart.setOption(tempOption);
        });
      });
    },
    downloadArea() {
      // console.log("this.value1---",this.value1)
      window.location.href =
        "https://lzrh.sprucesmart.com/api/v/download_daily?month="+this.value1;
    },
    downloadPro() {
      window.location.href =
        "https://lzrh.sprucesmart.com/api/v/download_monly?month="+this.value1;
    },
  },
};
</script>
<style lang="less">
.home {
  width: 100%;
  height: 100%;

  .daily-header {
    display: flex;
    justify-content: space-between;
    // align-items: center;
    width: 100%;
    height: 80px;
    background-color: #ffffff;
    font-size: 28px;
    font-family: PingFangSC;
    font-weight: 500;
    color: rgba(48, 48, 48, 1);
    line-height: 80px;
    // text-align: center;
    margin-bottom: 20px;
  }
  .daily-date {
    margin-left: 30px;
    font-size: 28px;
  }
  .week-button,
  .day-button {
    // display: inline-block;
    width: 150px;
    height: 38px;
    line-height: 38px;
    background-color: #00cc88;
    font-size: 16px;
    font-family: PingFangSC;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    margin-right: 10px;
    // position: absolute;
    // top: 90px;
  }
  .week-button {
    float: right;
    margin-top: 20px;
    // right: 200px;
  }
  .day-button {
    float: right;
    margin-top: 20px;
    // right: 20px;
    // top: 110px;
  }
  .daily-top {
    position: relative;
    display: flex;
    width: 100%;
    height: 579px;
    background: url("../../assets/bg.jpg") center no-repeat;
    background-size: 100% 100%;
    margin-bottom: 20px;
    .left {
      position: absolute;
      width: 750px;
      height: 485px;
      background: url("../../assets/map.png") center no-repeat;
      background-size: 100% 100%;
      top: 50px;
      left: 200px;
      font-size: 16px;
      .tj-text {
        position: absolute;
        top: 0px;
        right: 30px;
      }
      .nx-text {
        position: absolute;
        top: 130px;
        right: -50px;
      }
      .qh-text {
        position: absolute;
        bottom: 50px;
        right: -60px;
      }
      .xz-text {
        position: absolute;
        bottom: 150px;
        left: -100px;
      }
    }
    .right {
      position: absolute;
      flex: 1;
      // width: 500px;
      height: 410px;
      right: 0;
      top: 30px;
      .area {
        width: 45%;
        height: 24px;
        line-height: 24px;
        overflow: hidden;
        float: left;
        margin-top: 45px;
        .area-square {
          width: 28px;
          height: 28px;
          float: left;
          margin-right: 10px;
        }
        .area-text {
          font-size: 18px;
        }
        .gs-color {
          background-color: #b4d465;
        }
        .nx-color {
          background-color: #00b8ee;
        }
        .qh-color {
          background-color: #a394d9;
        }
        .xz-color {
          background-color: #efaa42;
        }
      }
      .cell {
        width: 110px;
        margin-top: 90px;
        margin-right: 50px;
        float: left;
        text-align: center;
        font-size: 16px;
      }
    }
  }
  .daily-top-2 {
    display: flex;
    justify-content: space-between;
    width: 100%;
    overflow: hidden;
    .charts {
      text-align: center;
      float: left;
      background-color: #ffffff;
      .chart-title {
        width: 100%;
        height: 39px;
        line-height: 39px;
        border-bottom: 1px solid #e1e1e1;
        font-size: 18px;
        font-family: PingFangSC;
        font-weight: 500;
        color: #303030;
        padding-left: 10px;
      }
    }
  }
  .table,
  .storetable {
    width: 100%;
    height: 100px;
    border: 1px solid #ccc;
    background: #ffffff;
    margin-bottom: 20px;
    text-align: center;
    th {
      border: 1px solid #ccc;
    }
    td {
      border: 1px solid #ccc;
    }
  }
  .ranklist {
    width: 100%;
    height: 591px;
    display: flex;
    justify-content: space-between;
    // align-items: center;
    .rankitem {
      width: 22.5%;
      height: 366px;
      background-color: #ffeacc;
      border-radius: 20px;
      .staffTitle {
        width: 100%;
        height: 66px;
        border-bottom: 2px solid #dddfef;
        font-size: 22px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(28, 42, 58, 1);
        line-height: 66px;
        padding-left: 42px;
        box-sizing: border-box;
        background-color: #ffe9c9;
        border-radius: 20px 20px 0 0;
        .jiangbeiimg {
          display: inline-block;
          width: 28px;
          height: 37px;
          margin-right: 10px;

          img {
            width: 100%;
            height: 100%;
            vertical-align: middle;
          }
        }
      }
      .scroll {
        width: 100%;
        height: 400px;
        background-color: #ffeacc;
        border-radius: 0 0 20px 20px;
        .content {
          .scrollitem {
            display: flex;
            justify-content: flex-start;
            height: 80px;
            line-height: 80px;
            .icon {
              display: inline-block;
              margin-left: 60px;
              margin-right: 22px;
              width: 28px;
              height: 37px;
              img {
                width: 100%;
                height: 100%;
                vertical-align: middle;
              }
            }
            .staffindex,
            .staffname {
              font-size: 22px;
              font-family: Helvetica;
              color: rgba(62, 3, 7, 1);
            }
            .staffavatar {
              margin-left: auto;
              margin-right: 60px;
              width: 40px;
              height: 40px;
              img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
              }
            }
          }
        }
      }
      .listhreecontent {
        height: 400px;
        background-color: #ffeacc;
        border-radius: 0 0 20px 20px;
        padding: 0 40px;
        .firstlist {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          height: 80px;
          border-bottom: 2px dashed #f4a393;
          .bigicon {
            width: 40px;
            height: 40px;
            background: url("https://static.sprucesmart.com/lzrh/lasticon.png")
              center no-repeat;
            background-size: 100% 100%;
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            margin-right: 13px;
            text-align: center;
            line-height: 40px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .staffinfo {
            font-size: 22px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(62, 3, 7, 1);
          }
          .staffavatar {
            margin-left: auto;
            width: 45px;
            height: 45px;
            img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }
        }
        .firstlist:nth-child(5) {
          border-bottom: none;
        }
      }
    }
  }
}
</style>